<template>
  <div v-if="items && items.length" :class="[baseCss, internalBgColor, app ? 'bcq-app-level' : null, `shadow-${elevation}-up`]" :is="tag" :style="{zIndex}">
    <table-layout equal-cells x-align="center" y-align="middle" :class="['bcq-bottom-navigation-buttons']">
      <row>
        <cell @click.native="onItemClick(index)" v-ripple v-for="(item, index) in items" :title="item.label" :key="index" :class="[selected !== index ? 'opacity-50' : null, item.disabled ? ['disabled', 'pointer-events-none'] : null, 'cursor-pointer', 'p-2', 'text-xs']">
          <icon v-if="item.icon" :name="item.icon" :size="2.25" :color="color" :color-lightness="colorLightness" />
          <div v-if="item.label" v-html="item.label" :class="['mt-3', 'truncate', setTextColor()]" />
        </cell>
      </row>
    </table-layout>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'
import computed from '../../mixins/computed'

export default {
  name: 'BottomNavigation',
  mixins: [
    props,
    methods,
    computed
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('bottom-navigation', ['select-none', 'fixed', 'bottom-0', 'left-0', 'right-0', 'duration-300', 'transition-all'])
    }
  },
  model: {
    prop: 'selected',
    event: 'input'
  },
  props: {
    selected: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    },
    tag: {
      type: String,
      default: 'section'
    },
    app: {
      type: Boolean
    },
    zIndex: {
      type: Number,
      default: 2000
    },
    bgColor: {
      type: String,
      default: 'white'
    },
    color: {
      type: String,
      default: 'gray'
    }
  },
  methods: {
    onItemClick (index) {
      this.$emit('input', index)
    }
  }
}
</script>
<style>
.bcq-bottom-navigation .bcq-bottom-navigation-buttons
{
  width: auto;
  margin: auto;
}

@media (max-width: 480px) {
  .bcq-bottom-navigation .bcq-table-layout.bcq-bottom-navigation-buttons
  {
    width: 100%;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/bottom-navigation/bottom-navigation.vue